"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.drawAll = exports.close = exports.open = exports.get = void 0;
var common_sidecar_1 = require("../../../main/common-sidecar");
var rogueMonofont_sidecar_1 = require("../monofont/rogueMonofont-sidecar");
var rogueDef_sidecar_1 = require("../rogueDef-sidecar");
var rogueRunner_sidecar_1 = require("../scene/rogueRunner-sidecar");
var rogueStats_sidecar_1 = require("./rogueStats-sidecar");
var _obj = null;
var get = function () {
    if (!_obj) {
        _obj = {
            isOpen: false,
            elapsed: 0,
        };
    }
    return _obj;
};
exports.get = get;
var open = function () {
    var obj = (0, exports.get)();
    obj.elapsed = 0;
    obj.isOpen = true;
};
exports.open = open;
var close = function () {
    var obj = (0, exports.get)();
    obj.isOpen = false;
};
exports.close = close;
var drawAll = function () {
    var obj = (0, exports.get)();
    if (!obj.isOpen) {
        return;
    }
    obj.elapsed += common_sidecar_1.common.getUpdateDelta();
    var x = 2;
    var y = 2;
    rogueMonofont_sidecar_1.rogueMonofont.write(x, y, 'You won!');
    y++;
    y++;
    rogueMonofont_sidecar_1.rogueMonofont.write(x, y, 'Final score: ' + rogueStats_sidecar_1.rogueStats.getStats().score);
    y++;
    y++;
    rogueMonofont_sidecar_1.rogueMonofont.write(x, y, 'Thanks for playing!');
    y++;
    y++;
    rogueMonofont_sidecar_1.rogueMonofont.write(x, y, 'Restart - q', rogueDef_sidecar_1.rogueDef.colors.light, rogueDef_sidecar_1.rogueDef.colors.darkBlue, function () {
        rogueRunner_sidecar_1.rogueRunner.softResetGame();
        (0, exports.close)();
    });
};
exports.drawAll = drawAll;
